import { useEffect, useState } from "react";
import SbModal from "uiCore/SbModal/SbModal";
import { getConsent } from "Api/apiService";
import { TERMS_VERSION } from "constants/legal.constants";

// Redirects to /legal until consent for the current terms version is recorded.
// Returns whether the org is enabled for legal consent by the BE.
const useConsentGate = (navigate) => {
  const [legalEnabled, setLegalEnabled] = useState(false);

  useEffect(() => {
    const checkConsent = () =>
      getConsent()
        .then((c) => {
          setLegalEnabled(!!c?.enabled);
          if (!c?.enabled) return; // org not enabled by BE, no tab / redirect
          if (!c.consent_id || c.terms_version !== TERMS_VERSION) navigate("/legal");
        })
        // Block the user on failure instead of silently skipping consent.
        .catch(() =>
          SbModal.warning({
            title: "Could not check your consent status",
            content: "Please retry.",
            okText: "Retry",
            keyboard: false,
            onOk: () => { checkConsent(); },
          })
        );
    checkConsent();
  }, [navigate]);

  return legalEnabled;
};

export default useConsentGate;
